import colors from "../../theme/colors";

/**
 * The expanded panel's action bar, as two button styles.
 *
 * They live in their own module rather than beside the panel because
 * SendToBorrowerActions needs the outline variant and the panel renders
 * SendToBorrowerActions — importing back the other way would make a cycle.
 *
 * Shared geometry across all four buttons — one height, radius and type scale —
 * so the bar reads as a single control strip rather than four separately-sized
 * ones.
 */
export const PANEL_BTN_SX = {
  height: 33,
  minHeight: 33,
  px: "12px",
  borderRadius: "8px",
  fontSize: 12.5,
  fontWeight: 600,
  textTransform: "none",
  whiteSpace: "nowrap",
  boxShadow: "none",
  "& .MuiButton-startIcon": { mr: "7px" },
};

/**
 * The quiet variant. Background and colour are set TOGETHER — overriding a
 * button's text colour alone against the theme's dark default is how you get
 * unreadable combinations.
 */
export const PANEL_BTN_OUTLINE_SX = {
  ...PANEL_BTN_SX,
  background: "#fff",
  color: colors.slate700,
  borderColor: colors.slate200,
  "&:hover": {
    background: "#FAFBFD",
    borderColor: colors.slate300,
    color: colors.slate900,
  },
};
